import { render, staticRenderFns } from "./exchangeRecord.vue?vue&type=template&id=dfabbf60&"
import script from "./exchangeRecord.vue?vue&type=script&lang=js&"
export * from "./exchangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./exchangeRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports